import {
  deleteTemplateRef,
  getInspectionTemplateRef,
  getOrderTemplateRef,
  getTimeActionTemplateRef,
  getSingleTemplateRef,
  saveTemplateRef,
  updateTemplateRef,
} from './template.service'

export async function getInspectionTemplates(payload) {
  const tmp = await getInspectionTemplateRef(payload)
  const data = tmp.data.data.map((item) => {
    return {
      id: item.id,
      name: item.name,
      type: item.inspection_type_name,
    }
  })
  return data
}

export async function getOrderTemplates(payload) {
  const tmp = await getOrderTemplateRef(payload)
  return tmp?.data?.data
}

export async function getTimeActionTemplates(payload) {
  const tmp = await getTimeActionTemplateRef(payload)
  return tmp?.data?.data
}

export async function getSingleTemplate(id: string) {
  const tmp = await getSingleTemplateRef(id)
  return tmp?.data?.data
}

export async function updateTemplate(payload: any) {
  return await updateTemplateRef(payload)
}

export async function saveTemplate(payload: any) {
  return await saveTemplateRef(payload)
}

export async function deleteTemplate(id: any) {
  return await deleteTemplateRef(id)
}
